import { createAction } from 'redux-actions'
import * as types from './types'
import { networkLogout } from './application'
import history from '../history'

const handleMessage = (message, dispatch) => {
  if (message === 'Transportador nao pode acessar essa carga') {
    history.push('/loads')
    dispatch(createAction(types.SHOW_USER_FEEDBACK)({
      feedbackTitle: 'Foi por pouco...',
      feedbackMessage: 'Esta carga foi atribuída para outro transportador... ',
      feedbackType: 'NOTIFICATION',
      styleFeedbackType: 'info',
      messageTimestamp: new Date().getTime(),
    }))
    return true
  }
  return false
}

const handleNetworkError = (statusCode, responseData) => (
  (dispatch) => {
    dispatch(createAction(types.IS_APPLICATION_LOADING)(false))
    if (statusCode === 401) {
      dispatch(networkLogout())
      if (responseData) {
        dispatch(createAction(types.SHOW_USER_FEEDBACK)({
          feedbackMessage: 'Usuário ou senha incorretos.',
          feedbackType: 'NOTIFICATION',
          styleFeedbackType: 'error',
          messageTimestamp: new Date().getTime(),
          status: 401,
        }))
      }
    } else if (statusCode === 422 || statusCode === 400) {
      if (responseData && responseData.messages) {
        responseData.messages.map((message) => {
          if (handleMessage(message, dispatch)) {
            return null
          }
          return dispatch(createAction(types.SHOW_USER_FEEDBACK)({
            feedbackMessage: message,
            feedbackType: 'NOTIFICATION',
            styleFeedbackType: 'error',
            messageTimestamp: new Date().getTime(),
          }))
        },
        )
      }
    } else if (statusCode >= 500) {
      dispatch(createAction(types.SHOW_USER_FEEDBACK)({
        feedbackMessage: 'Algo deu errado em nossos servidores, contacte um administrador. :"(',
        feedbackTitle: 'Isso é constrangedor...',
        feedbackType: 'NOTIFICATION',
        styleFeedbackType: 'error',
        messageTimestamp: new Date().getTime(),
      }))
    } else if (statusCode === 0) {
      dispatch(createAction(types.SHOW_USER_FEEDBACK)({
        feedbackMessage: 'Sua sessão expirou.',
        feedbackType: 'MESSAGE',
        styleFeedbackType: 'error',
        messageTimestamp: new Date().getTime(),
        status: 401,
      }))
      //   // WARNING: /\ remover apos fix com Alex (status 401 não está chegando no response)
    }
  }
)

export default handleNetworkError
